import { render, staticRenderFns } from "./ResumoAnaliticoDePonto.vue?vue&type=template&id=fda35dda"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports